import { AsYouType, isValidPhoneNumber } from 'libphonenumber-js';

import TextInput from '../../../components/ui/text-input';

const normalizePhoneNumber = (value = '') => {
  const str = String(value);
  const hasPlus = str.startsWith('+');
  const digits = str.replace(/\D/g, '').slice(0, 15);

  return (hasPlus ? '+' : '') + digits;
};

const formatPhoneNumber = (value = '') => {
  if (!value) return '';

  return new AsYouType('US').input(value);
};

const isPhoneNumberValid = (value = '') => {
  if (!value) return true;

  return isValidPhoneNumber(value, 'US');
};

const PHONE_VALIDATION_ERROR_MESSAGE = 'Please enter a valid phone number.';

const ProfilePhoneInput = ({
  name,
  value = '',
  placeholder,
  onChange,
  onBlur,
  disabled,
}) => {
  const handleChange = (event) => {
    const normalized = normalizePhoneNumber(event.target.value);
    const previousNormalized = normalizePhoneNumber(value);

    // When backspace removes only a formatting character (e.g. the ")" in
    // "(232)"), the normalized digits stay the same and React would re-render
    // the identical formatted value, making it look like backspace is broken.
    // Detect this case and strip the trailing digit so deletion progresses.
    if (
      normalized === previousNormalized &&
      event.target.value.length < formatPhoneNumber(value).length
    ) {
      event.target.value = normalized.slice(0, -1);
    } else {
      event.target.value = normalized;
    }

    event.target.setCustomValidity('');

    onChange?.(event);
  };

  const handleBlur = (event) => {
    if (!isPhoneNumberValid(event.target.value)) {
      event.target.setCustomValidity(PHONE_VALIDATION_ERROR_MESSAGE);
      event.target.reportValidity();
    } else {
      event.target.setCustomValidity('');
    }

    onBlur?.(event);
  };

  return (
    <TextInput
      name={name}
      value={formatPhoneNumber(value)}
      placeholder={placeholder}
      onChange={handleChange}
      onBlur={handleBlur}
      isDisabled={disabled}
      type="tel"
      inputMode="tel"
      autoComplete="tel"
    />
  );
};

export default ProfilePhoneInput;
